// extracted by mini-css-extract-plugin
module.exports = {"header":"modal_header__2jAGv","title":"modal_title__3Sp_j headLine-3","close":"modal_close__2nFio"};